import { isArray } from 'lodash';
import { UnitValue } from '../types';
import { getArrayRem } from './getArrayRem';
import { getRem } from './getRem';

export function getValue(value?: UnitValue | UnitValue[], unit?: 'rem') {
  if (unit === 'rem') {
    if (isArray(value)) {
      return getArrayRem(value);
    }

    return getRem(value);
  }

  return value;
}
